export const isFetchedData = (obj) => obj instanceof Object && 'loadingState' in obj;
//# sourceMappingURL=is-fetched-data.js.map